$(document).ready(function(){
    /// Main search input
    $('#pageheader .search-box input[type="text"]').bind('focusin focusout', function(e){
        $(this).closest('.search-box').toggleClass('focus', e.type == 'focusin');
    });
  
  
  

    /// Live search
    var preLoadLoadGif = $('<img src="//kartotekcopenhagen.com/cdn/shop/t/14/assets/ajax-load.gif?v=41356863302472015721682583854" />');
    var searchTimeoutThrottle = 500;
    var searchTimeoutID = -1;
    var currReqObj = null;
    var $resultsBox = $('<div class="results-box" />').appendTo('#pageheader .search-box');
    $('#pageheader .search-box input[type="text"]').bind('keyup change', function(){
        //Only search if search string longer than 2, and it has changed
	if($(this).val().length > 0 && $(this).val() != $(this).data('oldval')) {
            //Reset previous value
            $(this).data('oldval', $(this).val());
            
            // Kill outstanding ajax request
            if(currReqObj != null) currReqObj.abort();
            
            // Kill previous search
            clearTimeout(searchTimeoutID);
          
          	var $form = $(this).closest('form');
          
          	//Search term
          	var term = '*' + $form.find('input[name="q"]').val() + '*';
          var termShow = $form.find('input[name="q"]').val();
      
            //URL for full search page
            var linkURL = $form.attr('action') + '?type=product&q=' + term;
      
      
            
            //Show loading
            $resultsBox.html('<div class="load"></div>');
            
            // Do next search (in X milliseconds)
            searchTimeoutID = setTimeout(function(){
                //Ajax hit on search page
                currReqObj = $.ajax({
                  url: $form.attr('action'),
                  data: {
                    type: 'product',
                    view: 'json',
                    q: term,
                  },
                  dataType: 'json',
                  success: function(data){
                        currReqObj = null;
                        if(data.results_total == 0) {
                            //No results
                            $resultsBox.html('<div class="note">Sorry, no results.</div>');
                        } else {
                            //Numerous results
                            $resultsBox.empty();
                              $.each(data.results, function(index, item){
                                var xshow = 'wholesale'; //term for products we dont want to show
                                if(!(item.title.toLowerCase().indexOf(xshow) > -1)) {
                                  var $row = $('<a class="search-item"></a>').attr('href', item.url);
                                  $row.append('<div class="d-title">'+item.title+'</div>').mark(termShow); 
                                  $resultsBox.append($row);
                                  
                                }
                              });
                            $resultsBox.append('<a href="' + linkURL + '" class="btn" style="display:none;">View all results</a>');
                          
                        }
                    
                  }
                });
      
              
            }, searchTimeoutThrottle);
        } else if ($(this).val().length <= 2) {
            //Deleted text? Clear results
            $resultsBox.empty();
        }
    }).attr('autocomplete', 'off').data('oldval', '').bind('focusin', function(){
        //Focus, show results
        $resultsBox.fadeIn(200);
    }).bind('click', function(e){
        //Click, prevent body from receiving click event
        e.stopPropagation();
    });
    $('body').bind('click', function(){
        //Click anywhere on page, hide results
        $resultsBox.fadeOut(200);
    });
  

    //Search box should mimic live search string: products only, partial match
    $('.search-form, .search-form').on('submit', function(e){
      e.preventDefault();
      var term = $(this).find('input[name="q"]').val();
      var linkURL = $(this).attr('action') + '?type=product&q=' + term;
      window.location = linkURL;
    });

     $('.results-box').focus() 
    // search ends
     

     
     var initTopPosition= $('#header').offset().top;   
$(window).scroll(function(){
    if($(window).scrollTop() > initTopPosition)
         $('.results-box').fadeOut(200);
    else
         $('.results-box').delay(700).fadeIn(200);
  
});


});



// search drawer
$(document).ready(function(){
    /// Main search input
    $('.search-box-drawer input[type="text"]').bind('focusin focusout', function(e){
        $(this).closest('.search-box-drawer').toggleClass('focus', e.type == 'focusin');
    });
  
  
  

    /// Live search
    var preLoadLoadGif = $('<img src="//kartotekcopenhagen.com/cdn/shop/t/14/assets/ajax-load.gif?v=41356863302472015721682583854" />');
    var searchTimeoutThrottle = 500;
    var searchTimeoutID = -1;
    var currReqObj = null;
    var $resultsBoxDrawer = $('<div class="results-box-drawer" />').appendTo('.search-box-drawer');
    $('.search-box-drawer input[type="text"]').bind('keyup change', function(){
        //Only search if search string longer than 2, and it has changed
	if($(this).val().length > 0 && $(this).val() != $(this).data('oldval')) {
            //Reset previous value
            $(this).data('oldval', $(this).val());
            
            // Kill outstanding ajax request
            if(currReqObj != null) currReqObj.abort();
            
            // Kill previous search
            clearTimeout(searchTimeoutID);
          
          	var $form = $(this).closest('form');
          
          	//Search term
          	var term = '*' + $form.find('input[name="q"]').val() + '*';
          var termShow = $form.find('input[name="q"]').val();
      
            //URL for full search page
            var linkURL = $form.attr('action') + '?type=product&q=' + term;
      
      
            
            //Show loading
            $resultsBoxDrawer.html('<div class="load"></div>');
            
            // Do next search (in X milliseconds)
            searchTimeoutID = setTimeout(function(){
                //Ajax hit on search page
                currReqObj = $.ajax({
                  url: $form.attr('action'),
                  data: {
                    type: 'product',
                    view: 'json',
                    q: term,
                  },
                  dataType: 'json',
                  success: function(data){
                        currReqObj = null;
                        if(data.results_total == 0) {
                            //No results
                            $resultsBoxDrawer.html('<div class="note">Sorry, no results.</div>');
                        } else {
                            //Numerous results
                            $resultsBoxDrawer.empty();
                              $.each(data.results, function(index, item){
                                var xshow = 'wholesale'; //term for products we dont want to show
                                if(!(item.title.toLowerCase().indexOf(xshow) > -1)) {
                                  var $row = $('<a class="search-item"></a>').attr('href', item.url);
                                  $row.append('<div class="d-title">'+item.title+'</div>').mark(termShow); 
                                  $resultsBoxDrawer.append($row);
                                  
                                }
                              });
                            $resultsBoxDrawer.append('<a href="' + linkURL + '" class="btn" style="display:none;">View all results</a>');
                          
                        }
                    
                  }
                });
      
              
            }, searchTimeoutThrottle);
        } else if ($(this).val().length <= 2) {
            //Deleted text? Clear results
            $resultsBoxDrawer.empty();
        }
    }).attr('autocomplete', 'off').data('oldval', '').bind('focusin', function(){
        //Focus, show results
        $resultsBoxDrawer.fadeIn(200);
    }).bind('click', function(e){
        //Click, prevent body from receiving click event
        e.stopPropagation();
    });
    $('body').bind('click', function(){
        //Click anywhere on page, hide results
        $resultsBoxDrawer.fadeOut(200);
    });
  

    //Search box should mimic live search string: products only, partial match
    $('.search-form-drawer, .search-form-drawer').on('submit', function(e){
      e.preventDefault();
      var term = $(this).find('input[name="q"]').val();
      var linkURL = $(this).attr('action') + '?type=product&q=' + term;
      window.location = linkURL;
    });

     $('.results-box-drawer').focus() 
    // search ends

     
     var initTopPosition= $('#SearchDrawer').offset().top;   
$(window).scroll(function(){
    if($(window).scrollTop() > initTopPosition)
         $('.results-box-drawer').fadeOut(200);
    else
         $('.results-box-drawer').delay(700).fadeIn(200);
  
});



});